export const SHORT_NAME_MIN = 3;
export const SHORT_NAME_MAX = 16;

/** Mirror of backend shortname generator (alphanumeric, 3–16 chars; prefers ~12 when auto-generated). */
export const generateCatalogShortName = (name, { min = 12, max = SHORT_NAME_MAX } = {}) => {
  let base = String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

  if (!base) base = 'catalogitem';

  if (base.length < min) {
    let hash = 0;
    const src = String(name || base);
    for (let i = 0; i < src.length; i += 1) {
      hash = ((hash << 5) - hash) + src.charCodeAt(i);
      hash |= 0;
    }
    const pad = Math.abs(hash).toString(36);
    base = `${base}${pad}${pad}`.slice(0, min);
  }

  if (base.length > max) base = base.slice(0, max);
  while (base.length < min) base += 'x';
  return base.slice(0, max);
};

export const isValidCatalogShortName = (value) => {
  const v = String(value || '').trim().toLowerCase();
  return /^[a-z0-9]+$/.test(v) && v.length >= SHORT_NAME_MIN && v.length <= SHORT_NAME_MAX;
};
